<router-outlet></router-outlet>
<!-- 
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
    <p style="color: white;text-align: center;"> {{dynamicLoaderText}} </p>
</ngx-spinner> -->

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="triangle-skew-spin" [fullScreen]="true"
    [template]="inlineHTMLtemplate">
    <p style="color: white"> {{dynamicLoaderText}} </p>
</ngx-spinner>